import { RouteRecordRaw } from 'vue-router'
// 路由

/**
 * meta:{
 *     title:'登录', 页面标题/菜单标题
 *     icon:'',     菜单图标
 *     hidden:true, 是否在菜单中以隐藏
 *     hiddenTab:true 是否在tab栏中隐藏
 *     permission: 角色权限
 * }
 */

export const commonRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: {
      title: '首页',
      icon: 'dashboard'
    },
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home/home.vue'),
      meta: {
        title: '首页',
        icon: ''
      },
    }]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  },
  // 个人中心
  {
    path: '/user',
    component: () => import('@/layout/index.vue'),
    redirect: '/user/userInfo',
    meta: {
      title: '个人中心',
      icon: 'user',
      hidden: true,
      hiddenTab: true
    },
    children: [{
      path: 'userInfo',
      name: 'userInfo',
      component: () => import('@/views/userCenter/userInfo.vue'),
      meta: {
        title: '个人中心',
        icon: ''
      },
    }]
  },
  //  用户管理
  {
    path: '/userManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/userManage/list',
    meta: {
      title: '用户管理',
      icon: 'user',
      permission: 'user'
    },
    children: [{
      path: 'list',
      name: 'userlist',
      component: () => import('@/views/userManage/list.vue'),
      meta: {
        title: '用户列表',
        icon: '',
        permission: 'user:list'
      },
    },{
      path: 'invite',
      name: 'card_invite',
      component: () => import('@/views/cardManage/inviteList.vue'),
      meta: {
        title: '邀请记录',
        icon: '',
        permission: 'user:invite'
      },
    },{
      path: 'carbonlogs',
      name: 'carbonlogs',
      component: () => import('@/views/userManage/carbonLogs.vue'),
      meta: {
        title: '碳积分明细',
        icon: '',
        permission: 'user:carbonlogs'
      },
    },{
      path: 'consumeLogs',
      name: 'consumeLogs',
      component: () => import('@/views/userManage/consumeLogs.vue'),
      meta: {
        title: '消费券明细',
        icon: '',
        permission: 'user:consumeLogs'
      },
    },{
      path: 'shareRewardList',
      name: 'shareRewardList',
      component: () => import('@/views/userManage/shareRewardList.vue'),
      meta: {
        title: '邀请奖励发放审核',
        icon: '',
        permission: 'user:shareRewardList'
      },
    },{
      path: 'cancelList',
      name: 'cancelList',
      component: () => import('@/views/userManage/cancelList.vue'),
      meta: {
        title: '用户注销申请',
        icon: '',
        permission: 'user:cancelList'
      },
    },{
      path: 'details',
      name: 'userDetails',
      component: () => import('@/views/userManage/userDetail.vue'),
      meta: {
        title: '用户详情',
        icon: '',
        hidden:true,
        hiddenTab:true
      },
    }]
  },
  //  管理
  {
    path: '/fuelManage',
    component: () => import('@/layout/index.vue'),
    redirect: '/fuelManage/list',
    meta: {
      title: '产品管理',
      icon: 'oil',
      permission: 'fuel'
    },
    children: [{
      path: 'list',
      name: 'fuellist',
      component: () => import('@/views/fuelManage/list.vue'),
      meta: {
        title: '产品管理',
        icon: '',
        permission: 'fuel:list'
      },
    }]
  },
  //  会员卡管理
  {
    path: '/card',
    component: () => import('@/layout/index.vue'),
    redirect: '/card/list',
    meta: {
      title: '会员卡管理',
      icon: 'vip',
      permission: 'card'
    },
    children: [{
      path: 'list',
      name: 'cardlist',
      component: () => import('@/views/cardManage/list.vue'),
      meta: {
        title: '用户会员卡',
        icon: '',
        permission: 'card:list'
      },
    },{
      path: 'types',
      name: 'cardtypes',
      component: () => import('@/views/cardManage/types.vue'),
      meta: {
        title: '会员设置',
        icon: '',
        permission: 'card:types'
      },
    }]
  },
  {
    path: '/order',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/order/list',
    meta:{
      title:'订单管理',
      icon:'refund',
      permission: 'order'
    },
    children: [{
      path:'list',
      name:'order_list',
      component: ()=>import('@/views/orderManage/list.vue'),
      meta:{
        title:'订单列表',
        icon:'',
        permission: 'order:list'
      },
    },{
     path:'details',
     name:'order_details',
     component: ()=>import('@/views/orderManage/details.vue'),
     meta:{
       title:'订单详情',
       icon:'',
       hidden:true,
       hiddenTab:true
     }
   },{
     path:'refundList',
     name:'order_refund_list',
     component: ()=>import('@/views/orderManage/refund/list.vue'),
     meta:{
       title:'退款申请列表',
       icon:'',
       permission: 'order:refund'
     },
   },{
     path:'refundDetails',
     name:'order_refund_details',
     component: ()=>import('@/views/orderManage/refund/details.vue'),
     meta:{
       title:'退款申请详情',
       icon:'',
       hidden:true,
       hiddenTab:true
     },
   }]
  },
  {
    path: '/withdraw',
    component: ()=>import('@/layout/index.vue'),
    redirect:'/withdraw/applys',
    meta:{
      title:'提现管理',
      icon:'withdraw',
      permission: 'withdraw'
    },
    children: [{
      path:'applys',
      name:'withdraw_apply',
      component: ()=>import('@/views/financeManage/withdrawApply.vue'),
      meta:{
        title:'提现申请',
        icon:'',
        permission: 'withdraw:applys'
      },
    },{
      path:'tradeList',
      name:'tradeList',
      component: ()=>import('@/views/financeManage/tradeList.vue'),
      meta:{
        title:'余额支付记录',
        icon:'',
        permission: 'withdraw:trade_logs'
      },
    },{
      path:'details',
      name:'withdraw_details',
      component: ()=>import('@/views/financeManage/withdrawDetails.vue'),
      meta:{
        title:'提现详情',
        icon:'',
        hidden:true,
        hiddenTab:true
      },
    }]
  },
   //  合作商管理
   {
    path: '/partner',
    component: () => import('@/layout/index.vue'),
    redirect: '/partner/list',
    meta: {
      title: '合作商',
      icon: 'partner',
      permission: 'partner'
    },
    children: [{
      path: 'list',
      name: 'partnerlist',
      component: () => import('@/views/partnerManage/list.vue'),
      meta: {
        title: '合作商列表',
        icon: '',
        permission: 'partner:list'
      },
    },{
      path: 'applys',
      name: 'partner_apply',
      component: () => import('@/views/partnerManage/applyList.vue'),
      meta: {
        title: '合作申请',
        icon: '',
        permission: 'partner:applys'
      },
    },{
      path: 'type',
      name: 'partner_type',
      component: () => import('@/views/partnerManage/types.vue'),
      meta: {
        title: '合作类型设置',
        icon: '',
        permission: 'partner:type'
      },
    },{
      path: 'details',
      name: 'partnerDetails',
      component: () => import('@/views/partnerManage/partnerDetail.vue'),
      meta: {
        title: '合作商详情',
        icon: '',
        hidden: true,
        hiddenTab: true
      },
    }]

  },
  //  网点管理
  {
    path: '/station',
    component: () => import('@/layout/index.vue'),
    redirect: '/station/list',
    meta: {
      title: '网点管理',
      icon: 'station',
      permission: 'station'
    },
    children: [{
      path: 'list',
      name: 'stationList',
      component: () => import('@/views/stationManage/list.vue'),
      meta: {
        title: '网点列表',
        icon: '',
        permission: 'station:list'
      },
    },{
      path: 'details',
      name: 'stationDetails',
      component: () => import('@/views/stationManage/details.vue'),
      meta: {
        title: '网点详情',
        icon: '',
        hidden: true,
        hiddenTab: true
      },
    }]
  },

  
  {
    path: '/fb',
    component: () => import('@/layout/index.vue'),
    redirect: '/fb/list',
    meta: {
      title: '用户反馈信息',
      icon: 'feedback',
      permission: 'feedback'
    },
    children: [{
      path: 'list',
      name: 'dbList',
      component: () => import('@/views/feedbackManage/list.vue'),
      meta: {
        title: '用户反馈',
        icon: '',
        permission: 'feedback:list'
      },
    }]

    
  },
  //  角色管理
  // {
  //   path: '/role',
  //   component: () => import('@/layout/index.vue'),
  //   meta: {
  //     title: '角色管理',
  //     icon: 'user',
  //     permission: 'role'
  //   },
  //   children: [{
  //     path: 'roleList',
  //     name: 'roleList',
  //     component: () => import('@/views/roleManage/list.vue'),
  //     meta: {
  //       title: '角色列表',
  //       icon: '',
  //       permission: 'role:list'
  //     },
  //   },{
  //     path: 'permissionList',
  //     name: 'permissionList',
  //     component: () => import('@/views/roleManage/permissionList.vue'),
  //     meta: {
  //       title: '权限列表',
  //       icon: '',
  //       permission: 'role:permission'
  //     },
  //   },{
  //     path: 'adminList',
  //     name: 'adminList',
  //     component: () => import('@/views/roleManage/adminList.vue'),
  //     meta: {
  //       title: '管理员列表',
  //       icon: '',
  //       permission: 'role:admin'
  //     },
  //   },]
  // },

  

  //  系统
  {
    path: '/sys',
    component: () => import('@/layout/index.vue'),
    redirect: '/sys/index',
    meta: {
      title: '系统设置',
      icon: 'system',
      permission: 'system'
    },
    children: [{
      path: 'index',
      name: 'sysindex',
      component: () => import('@/views/systemManage/index.vue'),
      meta: {
        title: '系统设置',
        icon: '',
        permission: 'system:index'
      },
    }]
  },

  

  {
    path: '/:path(.*)*',
    component: () => import('@/views/err/404.vue'),
    meta: {
      title: '404',
      icon: '',
      hidden: true,
      hiddenTab: true
    }
  }
]